var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg043Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2H6C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18ZM5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V11.59L16.71 9.29C16.5222 9.10069 16.2666 8.9942 16 8.9942C15.7334 8.9942 15.4778 9.10069 15.29 9.29L11 13.59L8.71 11.29C8.52223 11.1007 8.26664 10.9942 8 10.9942C7.73336 10.9942 7.47777 11.1007 7.29 11.29L5 13.59V5ZM5 19V16.41L8 13.41L10.29 15.71C10.4778 15.8993 10.7334 16.0058 11 16.0058C11.2666 16.0058 11.5222 15.8993 11.71 15.71L16 11.41L19 14.41V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg043Image);
export default __webpack_public_path__ + "static/media/043-image.8ab718238a0dd8181bcb6e842370ccfe.svg";
export { ForwardRef as ReactComponent };